const ITEMS = [
  "Search Engine Optimization",
  "Ad Remarketing",
  "Website Optimization",
  "Google Business Profile",
  "Growth Strategy",
  "Google Ads Partner",
];

function Strip({ hidden }) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="whitespace-nowrap px-8 py-2 font-display text-3xl font-bold uppercase tracking-tight text-slate-900/10 sm:text-5xl">
            {item}
          </span>
          <svg
            className="h-4 w-4 shrink-0 text-flame"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4z" />
          </svg>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section
      data-testid="marquee-strip"
      className="relative overflow-hidden border-y border-slate-200 py-10 sm:py-14"
    >
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <Strip />
        <Strip hidden />
      </div>
    </section>
  );
}
